/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Participant } from './Participant';
import {
    ParticipantFromJSON,
    ParticipantFromJSONTyped,
    ParticipantToJSON,
} from './Participant';

/**
 * 
 * @export
 * @interface ParticipantsResponse
 */
export interface ParticipantsResponse {
    /**
     * 
     * @type {Array<Participant>}
     * @memberof ParticipantsResponse
     */
    participants: Array<Participant>;
    /**
     * 
     * @type {any}
     * @memberof ParticipantsResponse
     */
    count: any | null;
}

/**
 * Check if a given object implements the ParticipantsResponse interface.
 */
export function instanceOfParticipantsResponse(value: object): value is ParticipantsResponse {
    if (!('participants' in value) || value['participants'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ParticipantsResponseFromJSON(json: any): ParticipantsResponse {
    return ParticipantsResponseFromJSONTyped(json, false);
}

export function ParticipantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'participants': ((json['participants'] as Array<any>).map(ParticipantFromJSON)),
        'count': json['count'],
    };
}

export function ParticipantsResponseToJSON(value?: ParticipantsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'participants': ((value['participants'] as Array<any>).map(ParticipantToJSON)),
        'count': value['count'],
    };
}

